<div class="tab-list">
  @for (child of pageContent.PageSubContents; track child; let i = $index) {
    @if (child.PageContentTypeName == 'Dynamic Tab') {
      <app-dynamic-tab [pageContent]="child" [active]="i == activeIndex" (tabClicked)="activeIndex = i"></app-dynamic-tab>
    }
    @if (child.PageContentTypeName != 'Dynamic Tab') {
      <app-page-content-loop [pageContents]="[child]"></app-page-content-loop>
    }
  }
</div>
<div class="padding-bottom"></div>

@for (child of pageContent.PageSubContents; track child; let i = $index) {
  @if (i == activeIndex) {
    <app-page-content-loop [pageContents]="child.PageSubContents"></app-page-content-loop>
  }
}